(function() {
  function waitForRecharge(trigger, delayInterval, delayTimeout) {
    var intervalForRecharge = setInterval(function() {
      if (typeof window.ReChargeWidget != 'undefined') {
        clearInterval(intervalForRecharge);
        trigger();
      }
    }, delayInterval);
  }
  
  waitForRecharge(function() {
    $(document).ready(function() {
      createRechargeForm();
    });
  }, 50, 10000);

  // create recharge form
  function createRechargeForm() {
    var products = $('form[action="/cart/add"]');
    var configs = [];
    $(products).each(function(i) {
      if (!$(this).hasClass('lsg-product-form')) {
        if($(this).find('.rc-container-wrapper').length == 0) {
          var id = $(this).data('productid');
          $(this).prepend('<div class="bm-recharge-form-inject" data-id="'+id+i+'"></div>');
          configs.push({
            productId: id,
            injectionParent: '.bm-recharge-form-inject[data-id="'+id+i+'"]'
          });
        }
      }
    });

    configs.forEach(function(item){
      window.ReChargeWidget.createWidget(item);
    });

    // remove after skio turned off
    $('.skio-homepage').remove();
    $('.skio-pdp').remove();

    // modify second recharge form options
    setTimeout(function(){
      modifyDuplicateRechargeForm();
    }, 1000);
  }

  // recharge duplicate form click
  function modifyDuplicateRechargeForm() {
    var productList = [];

    $('form[action="/cart/add"]').each(function(i, form){
      var id = $(form).data('productid');
      
      if (productList.indexOf(id) > -1) {
        console.log('>> duplicate', id);
        var oneTime = $(form).find('.rc-option__onetime .rc_widget__option__selector');
        var subSave = $(form).find('.rc-option__subsave .rc_widget__option__selector');
        var oneTimeID = $(oneTime).find('input').attr('id') + '_' + i;
        var subSaveID = $(subSave).find('input').attr('id') + '_' + i;

        $(oneTime).find('input').attr('id', oneTimeID);
        $(oneTime).find('label').attr('for', oneTimeID);
        $(subSave).find('input').attr('id', subSaveID);
        $(subSave).find('label').attr('for', subSaveID);
      }

      productList.push(id);
    })

    $('.rc_container_wrapper+.bm-recharge-form-inject').remove();
    document.dispatchEvent(new CustomEvent('BmRechargeReady'));
    console.log('>> BmRechargeReady');
  }
})();